<template>
  <div class="right-wrapper">
    <div class="title">数据统计</div>
    <el-scrollbar class="scroll-main">
      <div class="data-list">
        <div class="data-box">
          <div class="data-title">
            <DataTitle :title="title1"></DataTitle>
          </div>
          <el-row class="content" :gutter="8">
            <el-col :span="12" style="margin-bottom: 8px">
              <div class="box1">
                <div class="num">
                  {{ projectCountInfo.total }}

                  <span class="unit">项</span>
                </div>
                <div class="text">计划建设项目总数</div>
              </div>
            </el-col>
            <el-col :span="12" style="margin-bottom: 8px">
              <div class="box1">
                <div class="num">
                  {{ projectCountInfo.invest }}

                  <span class="unit">万元</span>
                </div>
                <div class="text">总投资</div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="data-box">
          <DataTitle :title="title2"></DataTitle>
          <div style="height: 150px">
            <MyEchart :option="chartOption"></MyEchart>
          </div>
        </div>
        <div class="data-box">
          <div class="data-title">
            <DataTitle :title="title3"></DataTitle>
          </div>
          <el-row :gutter="8" class="content">
            <el-col :span="12">
              <div class="box1">
                <div class="num">{{ flyCountData.thisMonth }}</div>
                <div class="text">本月巡查次数</div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="box1">
                <div class="num">{{ flyCountData.total }}</div>
                <div class="text">巡查总次数</div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="data-box">
          <div class="data-title">
            <DataTitle :title="title4"></DataTitle>
          </div>

          <div class="spot-check">
            <div style="height: 150px">
              <MyEchart :option="chartOption2"></MyEchart>
            </div>
          </div>

          <div class="spot-check-list">
            <div class="list-title">整改详情列表</div>
            <div class="list-table">
              <el-table :data="tableData" border style="width: 100%" v-el-table-infinite-scroll="loadMore"
                height="200px" :header-cell-style="{
                    background: '#102A7C',
                    border: '1px solid #38509D',
                    color: '#fff',
                }" :cell-style="{ border: '1px solid #38509D' }">
                <el-table-column prop="plot" label="整改地块" align="center">
                </el-table-column>
                <el-table-column prop="progress" label="整改进度" align="center">
                  <template slot-scope="scope">
                    <div>{{ scope.row.isComplete === 1 ? '未整改' : '整改' }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="completeDate" label="整改日期" align="center">
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import ElTableInfiniteScroll from 'el-table-infinite-scroll';
import DataTitle from '../components/dataTitle.vue';
import MyEchart from '../components/MyEchart';
import * as Api from './Api';
import DicMixin from '../mixins/DicMixin';

export default {
    directives: {
        'el-table-infinite-scroll': ElTableInfiniteScroll,
    },
    mixins: [DicMixin],
    data () {
        return {
            title1: '重大工程情况',
            title2: '重大工程类型',
            title3: '无人机巡查信息',
            title4: '监察抽查/整改统计',
            tableData: [],
            directives: {
                'el-table-infinite-scroll': ElTableInfiniteScroll,
            },
            projectCountInfo: {
                invest: '',
                total: '',
            },
            // 重大工程情况数据
            projectConditionData: [],
            // 工程类型数据
            projectTypeCountData: [],
            // 飞行巡查统计数据
            flyCountData: {
                thisMonth: '', // 本月巡查次数
                total: '',
            },
            // 整改统计数据
            zhenggaiData: [
                {
                    value: 0,
                    name: '未整改',
                },
                {
                    value: 0,
                    name: '已整改',
                },
            ],
        };
    },
    components: { DataTitle, MyEchart },
    computed: {
        projectTypeCountChartData () {
            let list = [];
            let countList = this.projectTypeCountData;
            let dic = this.mixin_ProjectTypeDic;

            if (Array.isArray(countList)) {
                countList.forEach((item) => {
                    let key = item.typeFirst;
                    let obj = {
                        value: item.num,
                        name: dic[key],
                    };
                    list.push(obj);
                });
            }

            return list;
        },
        // 重大工程类型
        chartOption () {
            let data = this.projectTypeCountChartData || [];

            return {
                color: ['#0263FF', '#FF7723', '#8E30FF', '#2C46E8'],
                tooltip: {
                    trigger: 'item',
                },
                legend: {
                    orient: 'vertical',
                    top: '20',
                    right: '20',
                    textStyle: {
                        color: '#FFF',
                        rich: {
                            b: {
                                padding: [0, 0, 0, 20],
                                color: '#49F0FD',
                            },
                        },
                    },
                    formatter: (name) => {
                        let value = '';
                        data.forEach((item) => {
                            if (item.name === name) {
                                value = item.value;
                            }
                        });
                        return `${name}{b|${value}}`;
                    },
                },
                series: [
                    {
                        type: 'pie',
                        center: ['25%', '50%'],
                        radius: '80%',
                        itemStyle: {
                            normal: {
                                borderWidth: 3,
                                borderColor: '#000',
                            },
                        },
                        label: {
                            normal: {
                                position: 'inner',
                                show: false,
                            },
                        },
                        data,
                    },
                ],
            };
        },
        // 整改数据
        chartOption2 () {
            let data = this.zhenggaiData || [];
            return {
                // color: ['#0263FF', '#FF7723', '#8E30FF', '#2C46E8'],
                color: ['#0263FF', '#E4335E'],
                tooltip: {
                    trigger: 'item',
                },
                legend: {
                    orient: 'vertical',
                    top: '20',
                    right: '20',
                    textStyle: {
                        color: '#FFF',
                        rich: {
                            b: {
                                padding: [0, 0, 0, 20],
                                color: '#49F0FD',
                            },
                        },
                    },
                    formatter: (name) => {
                        let value = '';
                        data.forEach((item) => {
                            if (item.name === name) {
                                value = item.value;
                            }
                        });
                        return `${name}{b|${value}}`;
                    },
                },
                series: [
                    {
                        type: 'pie',
                        center: ['25%', '50%'],
                        radius: '80%',
                        itemStyle: {
                            normal: {
                                borderWidth: 3,
                                borderColor: '#000',
                            },
                        },
                        label: {
                            normal: {
                                position: 'inner',
                                show: false,
                            },
                        },
                        // data: [
                        //     // { value: 12, name: '工厂用地' },
                        //     // { value: 44, name: '办公用地' },
                        //     // { value: 56, name: '园区用地' },
                        //     // { value: 56, name: '住宅用地' },
                        // ],
                        data,
                    },
                ],
            };
        },
    },
    methods: {
        loadMore () { },
        /**
* 工程情况统计
*/
        getProjectCount () {
            Api.fetchProjectCount()
                .run()
                .then((res) => {
                    let resData = {};
                    if (res.length > 0) {
                        resData = res[0];
                    }
                    this.projectCountInfo = resData;
                });
        },
        /**
* 工程类型数量统计
*/
        getProjectTypeCount () {
            Api.fetchProjectTypeCount()
                .run()
                .then((res) => {
                    let result = res || [];
                    this.projectTypeCountData = result;
                });
        },
        /**
* 统计无人机巡查次数
*/
        getFlyCount () {
            Api.fetchFlyCount()
                .run()
                .then((res) => {
                    let data = {};
                    let list = res || [];
                    if (list.length > 0) {
                        data = list[0];
                    }
                    this.flyCountData = data;
                });
        },
        /**
* 查询整改统计
*/
        getRectifyCount () {
            let params = {
                type: 'GC', // 固定参数
            };
            Api.fetchRectifyCount(params)
                .run()
                .then((res) => {
                    let list = res || [];
                    let result = this.zhenggaiData;
                    list.forEach((item) => {
                        let isComplete = `${item.isComplete}`;
                        let num = item.num;
                        if (isComplete === '1') {
                            result[0].value = num;
                        } else if (isComplete === '0') {
                            result[1].value = num;
                        }
                    });
                    this.zhenggaiData = result;
                });
        },

        /**
* 查询整改列表
*/
        getRectifyList () {
            let list = [];
            let params = {
                type: 'GC', // 固定参数
            };
            Api.fetchRectifyList(params)
                .run()
                .then((res) => {
                    list = res || [];
                    this.tableData = list;
                });
        },
        // 获取数据字典
        getDic () {
            this.mixinGetProjectTypeDic();
        },
        getData () {
            this.getProjectCount();
            this.getProjectTypeCount();
            this.getFlyCount();
        },
    },
    mounted () {
        this.getDic();
        this.getData();
    },
};
</script>

<style lang="scss" scoped>
@import '~@Theme/config.scss';
@import '~@Theme/mixins/index.scss';

.right-wrapper {
  height: inherit;

  .title {
    padding-top: 11px;
    text-align: center;
    font-size: 18px;
    height: 37px;
    background-image: url(../imgs/titlebg01.png);
  }

  .scroll-main {
    height: calc(100% - 48px - 10px);
    overflow-x: hidden;

    ::v-deep .el-scrollbar__wrap {
      overflow-x: hidden;
    }

    ::v-deep .el-table {
      background-color: #071150;

      tr {
        background-color: #071150;
        color: #fff;
      }
    }

    ::v-deep .el-table--enable-row-hover {
      .el-table__body tr:hover>td.el-table__cell {
        background-color: #19267c;
      }
    }

    // //修改表格边框颜色

    .el-table--border:after,
    .el-table--group:after,
    .el-table:before {
      background-color: #38509d;
    }

    .el-table--border,
    .el-table--group {
      border-color: #38509d;
    }

    .el-table td,
    .el-table th.is-leaf {
      border-color: #38509d;
    }

    .el-table--border th,
    .el-table--border th.gutter:last-of-type {
      border-color: #38509d;
    }

    .el-table--border td,
    .el-table--border th {
      border-color: #38509d;
    }

    .data-list {
      margin-top: 15px;
      padding: 0 16px;

      .data-box {
        margin-top: 30px;

        .content {
          margin-top: 15px;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;

          .unit {
            padding-left: 2px;
          }

          .box1 {
            // width: 141px;
            height: 63px;
            background-color: #102a7c;
            display: flex;
            box-sizing: border-box;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .num {
              text-align: center;
              font-size: 20px;
              margin-top: 8px;
              line-height: 23px;
              height: 23px;
              font-weight: bold;
            }

            .text {
              font-size: 14px;
              text-align: center;
              margin-top: 5px;
              opacity: 0.6;
            }
          }

          .project-type {
            width: 100%;
            display: flex;

            .project-type-num {
              margin-top: 30px;

              .type {
                padding-top: 5px;

                .basics {
                  display: inline-block;
                  width: 12px;
                  height: 12px;
                  background-color: #0263ff;
                  margin-right: 5px;
                }

                .other {
                  display: inline-block;
                  width: 12px;
                  height: 12px;
                  background-color: #ff7723;
                  margin-right: 5px;
                }

                .people {
                  display: inline-block;
                  width: 12px;
                  height: 12px;
                  background-color: #8e30ff;
                  margin-right: 5px;
                }

                .industry {
                  display: inline-block;
                  width: 12px;
                  height: 12px;
                  background-color: #2c46e8;
                  margin-right: 5px;
                }

                .num {
                  margin-left: 5px;
                  color: #49f0fd;
                }
              }
            }
          }

          .spot-check {
            width: 100%;
            display: flex;

            .spot-check-num {
              margin-top: 30px;

              .type {
                padding-top: 5px;

                .rectify {
                  display: inline-block;
                  width: 12px;
                  height: 12px;
                  background-color: #0263ff;
                  margin-right: 5px;
                }

                .not-rectify {
                  display: inline-block;
                  width: 12px;
                  height: 12px;
                  background-color: #e4335e;
                  margin-right: 5px;
                }

                .total {
                  margin-right: 33px;
                }

                .num {
                  margin-left: 5px;
                  color: #49f0fd;
                }
              }
            }
          }
        }

        .spot-check-list {
          .list-title {
            text-align: center;
          }

          .list-table {
            margin-top: 12px;
          }
        }
      }
    }
  }
}
</style>
